import { Tooltip } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFile, faFileSignature } from "@fortawesome/pro-solid-svg-icons"
import { blue } from "@ant-design/colors"
import { useCreateAttachmentUrlMutation } from "./proposalsQueries"
import { approvedProposalAttachment, initialProposalAttachment } from "./proposalsModel"

type Props = {
    attachmentType: string
    attachmentId: string
}

const attachmentIconStyle = {cursor: 'pointer', color: blue.primary}

const AttachmentUrl = ({attachmentType, attachmentId}: Props) => {
    const createAttachmentUrl = useCreateAttachmentUrlMutation((url: string) => {
        window.open(url, '_blank')
      })

    switch(attachmentType){
        case approvedProposalAttachment: {
            return <Tooltip title={'Click to view approved proposal.'}>
                <FontAwesomeIcon 
                    icon={faFileSignature} 
                    style={attachmentIconStyle} 
                    onClick={() => { createAttachmentUrl.mutate(attachmentId)}} />
            </Tooltip>
        }
        case initialProposalAttachment: {
            return <Tooltip title={'Click to view proposal.'}>
                <FontAwesomeIcon 
                    icon={faFile} 
                    style={attachmentIconStyle} 
                    onClick={() => { createAttachmentUrl.mutate(attachmentId)}} />
            </Tooltip>
        }
    }

    return <></>
}

export default AttachmentUrl